import { Stack, Box, Card, Typography } from '@mui/material';

import { useWelcomeQuery } from '../../../api/getWelcomeDetails';
import Illustration from '../../../assets/icons/Illustration';
import colors from '../../../constants/colors';
import useAnalytics from '../../../hooks/useAnalytics';
import { getCookie } from '../../../utils/helpers';
import { LinkWithNoRouter } from '../../styledComponents/Link';

const ExploreMoreBenefitsCard = () => {
  const { track } = useAnalytics();
  const { data: welcomeData } = useWelcomeQuery();

  let clubCodeMembershipURL = '';

  if (welcomeData?.userInfo?.clubInfo?.membershipURL) {
    clubCodeMembershipURL = welcomeData?.userInfo?.clubInfo?.membershipURL;
  } else if (welcomeData?.userInfo?.clubCode) {
    clubCodeMembershipURL = welcomeData?.userInfo?.clubCode;
  } else {
    const mprZipCookie = getCookie('mpr_zip');
    const zipCookieInfo = mprZipCookie ? JSON.parse(mprZipCookie) : {};
    const postalCode = zipCookieInfo?.postalCode;
    clubCodeMembershipURL = `https://www.aaa.com/membership?ZipCodeEntry=${postalCode}`;
  }

  if (!clubCodeMembershipURL) return null;

  return (
    <Card
      data-testid="clubCodeMembershipBenefits"
      component={Stack}
      spacing={4}
      sx={{
        boxShadow: '0px 4px 8px rgba(25, 30, 43, 0.08)',
        p: { mobile: 2, tablet: 3, desktop: 2 },
        borderRadius: 2,
        height: 'auto',
      }}
    >
      <Stack
        direction={{ mobile: 'column', tablet: 'row', desktop: 'column' }}
        spacing={{ mobile: 2, tablet: 3, desktop: 2 }}
      >
        <Box
          sx={{
            backgroundColor: colors.csaaGray,
            borderRadius: 1,
            width: { mobile: 1, tablet: '50%', desktop: 1 },
            textAlign: 'center',
            py: 1,
          }}
        >
          <Illustration />
        </Box>
        <Stack spacing={1} width={1} justifyContent="center">
          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              fontSize: { mobile: 16, tablet: 18 },
              lineHeight: '25px',
              fontFamily: 'Cabin',
              fontKerning: 'normal',
              color: colors.csaaBlack,
            }}
          >
            Explore more benefits of AAA Membership
          </Typography>
        </Stack>
        <Stack
          direction="row"
          justifyContent="flex-end"
          width={{ mobile: 1, tablet: '50%', desktop: 1 }}
          alignItems="center"
        >
          <LinkWithNoRouter
            href={clubCodeMembershipURL}
            target="_blank"
            sx={{
              fontSize: { mobile: 16, tablet: 18 },
              fontWeight: 700,
              lineHeight: '24px',
              p: 1,
              '&:hover': {
                backgroundColor: colors.blackInteractiveButtonHover,
                textDecoration: 'none',
              },
            }}
            onClick={() =>
              track('Promotion Clicked', {
                event_type: 'Link Accessed',
                contents: 'Explore more benefits of AAA Membership',
                link: 'Go now',
                location: 'Secondary Card',
              })
            }
          >
            Go now
          </LinkWithNoRouter>
        </Stack>
      </Stack>
    </Card>
  );
};

export default ExploreMoreBenefitsCard;
